// extracted by mini-css-extract-plugin
export default {"PreviewWidget":"PreviewWidget_PreviewWidget__PamhD","PreviewArea":"PreviewWidget_PreviewArea__9b76P","VarList":"PreviewWidget_VarList__b3Yrk"};